import { Box } from '@mui/material';

// imports: styles
import { imageInfoStyles } from 'apps/studio/studio-tab/components/image-info/ImageInfoStyles';

// imports: assets
import { ReactComponent as Delete } from 'core/assets/svg/export-image/delete.svg';
import { ReactComponent as Download } from 'core/assets/svg/export-image/download.svg';
import { ReactComponent as ReuseDark } from 'core/assets/svg/modal-icons/reuse-dark6.svg';
import { ReactComponent as Reuse } from 'core/assets/svg/modal-icons/reuse.svg';
import BaseButton from 'core/components/button/BaseButton';

// imports: components
import BaseTypography from 'core/components/typography/BaseTypography';
import { DELETED_CHARACTER_STATUS } from 'core/constants/constants';
import { PricingModalSource } from 'core/constants/enums/PricingModalSource.ts';
import { PricingPagePlans } from 'core/constants/enums/PricingPagePlans.ts';
import { ToastType } from 'core/constants/enums/ToastTypeEnum.ts';
import { sendToast } from 'core/layouts/components/toast/ToastUtils';
import { reusableStyles } from 'core/layouts/ui-blocks/ReusableStyles';

// imports: constants
import { APP, HISTORY, TEXT_TO_IMAGE } from 'core/navigation/Routes';
import {
	setShowConfirmPromptScreen,
	userProfileSelector,
} from 'core/store/reducers/appReducer/AppSlice';
import { handleReusePrompt } from 'core/store/reducers/appReducer/appSliceThunk';
import { toggleSubscriptionModal } from 'core/store/reducers/profileReducer/ProfileSlice';
import {
	setRandomiseStudioPrompt,
	toggleMultiDeletePromptConfirmationModal,
} from 'core/store/reducers/studioReducer/StudioSlice';
import { downloadImage } from 'core/utils/utils';
import React, { useMemo } from 'react';

// imports: redux
import { useDispatch, useSelector } from 'react-redux';

// imports: utils
import { useNavigate } from 'react-router-dom';

const styles = imageInfoStyles;
export default function ImageInfoBottomBar(props) {
	const { selectedPrompt, handleClose, feedPromptsModalType, showPublishPrompt, showReusePrompt } =
		props;
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const disableButtons = useMemo(() => selectedPrompt.loading, [selectedPrompt.loading]);
	const isUsedCharacterDeleted =
		selectedPrompt?.attributes?.character?.status === DELETED_CHARACTER_STATUS;
	const hasCharacter = Boolean(selectedPrompt?.attributes?.character?.id);
	const userProfileData = useSelector(userProfileSelector);
	const isFreeUser = userProfileData.currentPlan === PricingPagePlans.FREE;
	return (
		<Box id="move-to-studio-cont-wrapper" sx={styles.detailScreenButtonsCont}>
			{!selectedPrompt.published && showPublishPrompt && (
				<BaseButton
					id="publish-prompt"
					styles={[styles.actionButtonStyles, styles.publishPromptButton]}
					disabled={disableButtons}
					onClick={(e) => {
						e.stopPropagation();
						dispatch(setShowConfirmPromptScreen(true));
					}}
				>
					<BaseTypography variant="b1_bold" styles={{ color: 'inherit' }}>
						Publish
					</BaseTypography>
				</BaseButton>
			)}

			<Box sx={[reusableStyles.flexRow, { flexGrow: 1, gap: 'inherit', flexWrap: 'wrap' }]}>
				<BaseButton
					id="delete-button"
					disabled={disableButtons}
					styles={[styles.actionButtonStyles, styles.downloadButton]}
					onClick={() => {
						dispatch(
							toggleMultiDeletePromptConfirmationModal({
								open: true,
								prompt: [
									{
										generationId: selectedPrompt?.generationId,
										batchId: selectedPrompt?.batchId,
									},
								],
							}),
						);
					}}
				>
					<Delete />
				</BaseButton>
				<BaseButton
					id="download-button"
					disabled={disableButtons}
					styles={[styles.actionButtonStyles, styles.downloadButton]}
					onClick={() => {
						downloadImage(selectedPrompt?.media || '');
					}}
				>
					<Download />
				</BaseButton>
				{showReusePrompt && !isUsedCharacterDeleted && !hasCharacter && (
					<BaseButton
						id="reuse-prompt"
						styles={[
							styles.actionButtonStyles,
							styles.downloadButton,
							{
								backgroundColor: selectedPrompt.published ? 'colors.light1' : 'colors.dark3',
								'&:hover': {
									backgroundColor: selectedPrompt.published ? 'colors.light1' : 'colors.dark3',
								},
							},
						]}
						onClick={(e) => {
							e.stopPropagation();
							if (isFreeUser) {
								sendToast(ToastType.UPGRADE_TO_USE_MAGIC_MODE_AND_PRO_MODE);
								dispatch(
									toggleSubscriptionModal({
										open: true,
										from: PricingModalSource.STUDIO,
									}),
								);
							} else {
								dispatch(handleReusePrompt());
								if (feedPromptsModalType === HISTORY) {
									navigate(`/${APP}/${TEXT_TO_IMAGE}`);
									// NOTE: SETTING RANDOMISE STUDIO PROMPT TO FALSE
									dispatch(setRandomiseStudioPrompt(false));
								}
							}
							handleClose();
						}}
					>
						{selectedPrompt.published && (
							<BaseTypography variant="b1_bold" styles={{ color: 'inherit' }}>
								Reuse prompt
							</BaseTypography>
						)}
						{!selectedPrompt.published ? <Reuse /> : <ReuseDark />}
					</BaseButton>
				)}
			</Box>
		</Box>
	);
}
